<template>
  <el-card shadow="hover" class="box-card" body-style="padding: 16px; padding-top: 8px;">
    <div slot="header" class="clearfix">
      <span>Updates</span>
      <el-button
        @click="$router.push('/home/updates')"
        style="float: right; padding: 3px 0"
        type="text"
      >See All</el-button>
    </div>
    <span v-if="updates == null || updates.length == 0" class="center-message">No Updates</span>
    <div v-else>
      <div v-for="update in updates" :key="update.o_id" class="text item">
        <div @click="showUpdate(update, true)" class="list-tile">
          <span class="list-title">{{update.update_title}}</span>
          <div style="display: flex">
            <span class="list-subtext" style="margin-right: auto;">{{getFullName(update.user)}}</span>
            <span class="list-subtext">{{moment(update.updated_at).fromNow()}}</span>
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import {mapFields} from "vuex-map-fields";

export default {
    props: ["selected_update"],
    data() {
        return {updates: []};
    },
    mounted() {
        if (this.selectedTerms != null && this.publishedUpdates == null) {
            this.$store.dispatch(
                "pullPublishedUpdates",
                this.buildTermPageURI(
                    "/api/v1/updates/published",
                    this.selectedTerms,
                    1
                )
            );
        }
        if (this.publishedUpdates) {
            this.updates = this.publishedUpdates.data.slice(0, 5);
        }
    },
    computed: {...mapFields(["user", "selectedTerms", "publishedUpdates"])},
    watch: {
        publishedUpdates(val) {
            this.updates = val.data.slice(0, 5);
        },
        selectedTerms() {
            if (this.selectedTerms != null && this.publishedUpdates == null) {
                this.$store.dispatch(
                    "pullPublishedUpdates",
                    this.buildTermPageURI("/api/v1/updates/self", this.selectedTerms, 1)
                );
            }
        }
    },
    methods: {
        getUpdates() {
            this.$store.dispatch(
                "pullPublishedUpdates",
                this.buildTermPageURI(
                    "/api/v1/updates/published",
                    this.selectedTerms,
                    1
                )
            );
        },
        showUpdate(val) {
            this.$router.push("/home/updates/" + val.o_id);
        }
    }
};
</script>
